import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Search, ArrowLeft, Home } from 'lucide-react';
export function NotFoundPage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-6543">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-md w-full text-center" data-id="element-6544">
        <div className="text-9xl font-bold text-surface border-border mb-8 select-none" style={{
        WebkitTextStroke: '2px #27272A'
      }} data-id="element-6545">
          404
        </div>
        <h1 className="text-3xl font-bold mb-4" data-id="element-6546">Page not found</h1>
        <p className="text-textMuted mb-8 leading-relaxed" data-id="element-6547">
          We couldn't find the page you're looking for. It might have been
          moved, deleted, or perhaps the URL is incorrect.
        </p>

        <div className="relative mb-8 text-left" data-id="element-6548">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-textMuted" data-id="element-6549" />
          <input type="text" placeholder="Search Booker..." className="w-full pl-12 pr-4 py-3 bg-surface border border-border rounded-xl text-sm focus:outline-none focus:border-primary" data-id="element-6550" />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-6551">
          <button onClick={() => window.history.back()} className="w-full sm:w-auto px-6 py-3 bg-surface border border-border rounded-xl font-medium hover:bg-surfaceHover transition-colors flex items-center justify-center gap-2" data-id="element-6552">
            <ArrowLeft className="w-4 h-4" data-id="element-6553" /> Go Back
          </button>
          <Link to="/" className="w-full sm:w-auto px-6 py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2" data-id="element-6554">
            <Home className="w-4 h-4" data-id="element-6555" /> Go Home
          </Link>
        </div>
      </motion.div>
    </div>;
}